<template>
    <div class="container">
        <div class="form">

            <div class="title">
                <div class="t">修改密码</div>
                <div class="a">修改密码</div>
            </div>

            <el-form style="width: 70%;" label-width="auto" :rules="rules" ref="ruleForm" :model="form">
                <el-form-item prop="username" label="账号">
                    <el-input disabled v-model="form.username"></el-input>
                </el-form-item>

                <el-form-item prop="email" label="邮箱地址">
                    <el-input disabled v-model="form.email">
                        <template slot="append">
                            <div class="yzm">
                                <el-button :disabled="isCounting" @click="getVerificationCode">
                                    {{ buttonText }}
                                </el-button>
                            </div>
                        </template>
                    </el-input>
                </el-form-item>

                <el-form-item prop="email_code" label="邮箱验证码">
                    <el-input v-model="form.email_code"></el-input>
                </el-form-item>

                <el-form-item prop="pwd" style="margin-top: 65px;" label="密码">
                    <el-input show-password v-model="form.pwd"></el-input>
                </el-form-item>

                <el-form-item prop="agian_pwd" label="确认密码">
                    <el-input show-password v-model="form.agian_pwd"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button @keyup.enter="handle_submit()" @click="handle_submit()" style="width: 316px;"
                        type="primary">确认修改</el-button>
                </el-form-item>


            </el-form>

        </div>
    </div>
</template>

<script>
export default {
    name: 'resetPasswords',
    mixins: [],
    props: {},
    data() {
        return {
            user_info: {},
            form: {
                username: "",
                email: "",
                email_code: "",
                pwd: "",
                agian_pwd: "",
            },
            isCounting: false,
            countdown: 60,
            buttonText: '获取验证码',
            timer: null,
            rules: {
                username: [
                    { required: true, message: '请输入账号', trigger: 'blur' }

                ],
                email: [
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' }
                ],
                email_code: [
                    { required: true, message: '请输入邮箱验证码', trigger: 'blur' }
                ],
                pwd: [
                    { required: true, message: '请输入登录密码', trigger: 'blur' }
                ],
                agian_pwd: [
                    { required: true, message: '请再次输入登录密码', trigger: 'blur' }
                ],
            },
        }
    },
    methods: {
        async send_code() {
            const res = await this.$http.post('/api/index/register')
            console.log(res, '----->');
        },
        async handle_submit() {
            if (this.form.pwd != this.form.agian_pwd) {
                this.$message({
                    message: '两次密码输入不一致',
                    type: 'warning'
                });
                return
            }
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    const res = await this.$http.post('/api/user/edit_pwd', this.form)
                    console.log(res, '----->');

                    if (res.data.code == 200) {
                        // 保存数据
                        localStorage.setItem('user_info', JSON.stringify(res.data.data.info));
                        this.$message({
                            message: '密码修改成功！',
                            type: 'success'
                        });
                        setTimeout(() => {
                            this.$router.push({ path: '/loGin' })
                        }, 3000);

                    } else {

                        this.$message({
                            message: res.data.msg,
                            type: 'warning'
                        });

                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });


        },
        getVerificationCode() {
            if (this.isCounting) return; // 如果正在倒计时，直接返回
            if (!this.form.email) {
                this.$message({
                    message: '请输入邮箱地址',
                    type: 'warning'
                });
                return
            }

            // 发起请求获取验证码
            this.sendVerificationCode();


        },
        async sendVerificationCode() {

            const res = await this.$http.post('/api/index/sendEmail', {
                email: this.form.email,
                event: 3,
            })
            console.log(res, '----->');

            if (res.data.code == 200) {
                // 保存数据
                this.$message({
                    message: '验证码已发送到您的邮箱',
                    type: 'success'
                });
                // 开始倒计时
                this.isCounting = true;
                this.buttonText = `${this.countdown}秒后重新获取`;

                this.timer = setInterval(() => {
                    this.countdown--;
                    this.buttonText = `${this.countdown}秒后重新获取`;

                    if (this.countdown <= 0) {
                        clearInterval(this.timer);
                        this.isCounting = false;
                        this.countdown = 60; // 重置倒计时
                        this.buttonText = '重新获取验证码';
                    }
                }, 1000);

            } else {

                this.$message({
                    message: res.data.msg,
                    type: 'warning'
                });

            }

            console.log('发送验证码到:', this.form.email);
        },
    },
    beforeDestroy() {
        // 清理定时器
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
    created() {
        this.user_info = localStorage.getItem('user_info')
        this.user_info = JSON.parse(this.user_info)
        console.log(this.user_info, '---this.user_info-->');
        this.form.username = this.user_info.USERNAME
        this.form.email = this.user_info.EMAIL

    },
    mounted() { },
    computed: {},
    watch: {},
}
</script>

<style scoped lang="scss">
.container {

    .form {
        width: 870px;
        padding-top: 62px;
        padding: 62px 172px 0 172px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .title {
            width: 70%;
            border-bottom: 1px solid #d0d0d0;
            padding-bottom: 40px;
            margin-bottom: 30px;

            .t {
                font-size: 20px;
                color: #333333;
            }

            .a {
                font-size: 16px;
                color: #999999;
            }
        }

        .yzm {
            color: #d32737;
        }

    }
}

::v-deep .el-input-group__append {
    background-color: #fff;
    border-left: 0px solid transparent !important;
}
</style>